import Typography from '@mui/material/Typography';
import { truncateIfTooLong } from 'src/util/truncate';
import { AvatarNext } from 'src/components/AvatarNext';
import Stack from '@mui/material/Stack';
import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';
import { ParticipantAdminDetails } from '../ParticipantAdminDetails';
import { isAdmin } from 'functions/src/types/firestore/User/util';
import { useAuth } from 'src/contexts/AuthContext';

export type CompetitorInfoProps = {
  avatarSrc: string;
  name?: string;
  countFill?: number;
  countMax?: number;
  isSoloTeam: boolean;
  member: Omit<
    Member,
    'checkedIn' | 'userId' | 'username' | 'imgUrl' | 'status' | 'tournamentId'
  >;
};

export const CompetitorInfo: React.FC<CompetitorInfoProps> = ({
  avatarSrc,
  name = 'Auto Team',
  countFill,
  countMax,
  isSoloTeam,
  member,
}) => {
  const { imgUrl, username, userId, checkedIn, status, tournamentId, ...rest } =
    member;
  const nameTruncated = truncateIfTooLong(name, 24);
  const { user } = useAuth();
  const isAuthenticated = isAdmin(user?.email);

  return (
    <Stack direction="row">
      <AvatarNext
        sx={{
          width: '50px',
          height: '50px',
          mr: 1,
        }}
        alt="competitor image"
        src={avatarSrc}
      />

      <Typography
        variant="subtitle1"
        sx={{
          textTransform: 'uppercase',
          alignSelf: 'center',
          pl: 3,
        }}
      >
        {nameTruncated} &nbsp;
      </Typography>
      {isSoloTeam && isAuthenticated && <ParticipantAdminDetails {...rest} />}

      {!countFill && !countMax && (
        <Typography
          variant="subtitle1"
          sx={{
            alignSelf: 'center',
            color: 'rgba(204, 226, 255, 0.7)',
            pl: 2,
          }}
        >{`${countFill}/${countMax}`}</Typography>
      )}
    </Stack>
  );
};
